module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1201-retro.6eeb8f75.jpg";